import Cookies from "js-cookie";
import React, { useContext } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { AdminActiveAdministrationTabContext } from "../../../Context/AdminActiveAdministrationTabContext/AdminActiveAdministrationTabContext";
import { TabContent } from "../../SharedComponents/TabContent/TabContent";
import { AdminAccountancy } from "../AdminAccountancy/AdminAccountancy";
import { AdminCountries } from "../AdminCountries/AdminCountries";
import { AdminCurrentAccountUsers } from "../AdminCurrentAccountUsers/AdminCurrentAccountUsers";
import { AdminPageHeader } from "../AdminPageHeader/AdminPageHeader";
import "./AdminAdminstration.css";

const SUPERADMIN = "SUPERADMIN";

export const AdminAdminstration = () => {
  const accessLevel = Cookies.get("access_level");
  const { activeTab, setActiveTab } = useContext(
    AdminActiveAdministrationTabContext
  );

  if (accessLevel !== SUPERADMIN)
    return (
      <div className="AdminAdminstration">
        <AdminPageHeader title="pageTitles.administration" />
        <AdminCurrentAccountUsers />
      </div>
    );

  return (
    <div className="AdminAdminstration">
      <AdminPageHeader title="pageTitles.administration" />
      <Tabs
        selectedIndex={activeTab}
        onSelect={(tabIndex) => setActiveTab(tabIndex)}
        style={{ height: "calc(100% - 153px)" }}
      >
        <TabList className="UserProfileDetails__tablist">
          <Tab className="UserProfileDetails__tablist-tab">
            <TabContent text="sectionTitles.users" />
          </Tab>
          <Tab className="UserProfileDetails__tablist-tab">
            <TabContent text="sectionTitles.countries" />
          </Tab>
          <Tab className="UserProfileDetails__tablist-tab">
            <TabContent text="sectionTitles.accountancy" />
          </Tab>
        </TabList>

        <TabPanel style={{ height: "calc(100% - 55px)" }}>
          <AdminCurrentAccountUsers />
        </TabPanel>
        <TabPanel style={{ height: "calc(100% - 55px)" }}>
          <AdminCountries />
        </TabPanel>
        <TabPanel style={{ height: "calc(100% - 55px)" }}>
          <AdminAccountancy />
        </TabPanel>
      </Tabs>
    </div>
  );
};
